import React, { forwardRef } from 'react';
import { Link as ReachLink } from '@reach/router';
import { useSelector } from 'react-redux';
import { basepathSelector } from 'src/redux/app/selectors';

const Link = forwardRef(({ to, children, bold, ...props }, ref) => {
  const basepath = useSelector(basepathSelector);

  return (
    <ReachLink ref={ref} to={basepath + to} {...props}>
      {children}
    </ReachLink>
  );
});

export default Link;
